<template>
  <div
    :class="{
      'has-ai-option': isAITestGroup
    }"
  >
    <p class="onboarding-title">
      {{ $i18nPresenter.t("Choose one to start: ") }}
    </p>
    <div class="options__wrapper">
      <div
        v-for="(option, optionIndex) in onboardingOptions"
        :key="optionIndex"
        class="options-card"
        :class="{'hidden': option.type === 'ai' && !isAITestGroup}"
        @click="handleClickOnboardingOption(option)"
      >
        <div class="options-card__image">
          <img :src="option.image" />
        </div>
        <div class="options-card__name">
          {{ $i18nPresenter.t(option.name) }}
          <aha-spinner class="ml-1.5" v-if="$store.state.importStatus == 2 && optionIndex == 1" />
        </div>
        <div v-if="option.hoverImage || option.hoverImageFr" class="options-card__desc-img">
          <img v-if="getPresenterLocale === 'fr'" :src="option.hoverImageFr" />
          <img v-else :src="option.hoverImage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// services
import { mapGetters, mapActions } from 'vuex'

// modules
import constants from '@/constant'
import utils from '@/util'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  mixins: [CreateNewPresentationMixin],
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['isAITestGroup', 'getPresenterLocale']),
    onboardingOptions() {
      if (!this.isAITestGroup) {
        return constants.onboardingv3Options.slice(0, -1)
      }

      return constants.onboardingv3Options
    },
  },
  created() {
    this.preloadOnboardingImages()
  },
  methods: {
    ...mapActions(['setIsOnboardingV3ShowingAction']),
    preloadOnboardingImages() {
      utils.preloadOnboardingV3Images()
    },

    handleClickOnboardingOption(option) {
      if (!option || (option.type === 'ai' && !this.isAITestGroup)) return
      if (option.type == 'create') {
        this.createNewPresentation(constants.Events.TRIGGER.BLANK_FROM_ONBOARDING_V3)
      } else if (option.type == 'upload') {
        this.$store.state.openImportModal = true
      } else if (option.type == 'templates') {
        this.setIsOnboardingV3ShowingAction(false)
        this.$router.push({ name: 'TemplateLibrary' })
      } else if (option.type == 'ai') {
        this.createNewPresentation('AI Quiz Generator from Onboarding v3')
      }
      this._trackGAEvent(option)
    },

    _trackGAEvent(option) {
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_LIST,
        'Onboarding v3 > Select option',
        option.name,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.has-ai-option {
  @media (min-width: 1200px) {
    margin-top: -160px;
  }
}

.onboarding-title {
  @apply text-2xl font-bold mb-6 lg:mb-8 text-center;
}

.options__wrapper {
  @apply flex lg:flex-row lg:gap-x-8 flex-col gap-y-5 px-4;
  .options-card {
    @apply rounded-xl bg-base-0 p-3 lg:p-5 cursor-pointer lg:block flex gap-x-4 relative;
    box-shadow: 0px 8px 0px #DFE3E9;
    transition: 0.1s ease-in;

    &:active:not(:disabled) {
      @apply transform translate-y-1.5 shadow-none;
    }

    &:hover:not(:active):not(:disabled) {
      @apply transform translate-y-0.25;
    }

    &:hover {
      box-shadow: 0px 6px 0px #DFE3E9;

      @media (min-width: 1200px) {
        .options-card__desc-img {
          visibility: visible;
          transform: translateY(0);
        }
      }
    }

    &.hidden {
      display: none;
    }
    .options-card__image {
      @apply lg:w-full sm:w-1/3 w-1/4;
    }
    .options-card__name {
      @apply font-bold lg:text-center lg:pt-4 flex justify-center items-center text-lg;
    }
    .options-card__desc-img {
      display: none;
      visibility: hidden;
      position: absolute;
      top: calc(100% + 20px);
      right: 0;
      width: max-content;
      height: auto;
      transform: translateY(10px);
      transition: 0.2s transform ease-out;

      @media (min-width: 1200px) {
        display: inline-block;
      }
    }
  }
}
</style>
